import isEmpty from 'lodash/isEmpty';
import EMPTY_DRAFT_FIELD from '../../utils/constants';

export function formatGeographicRestriction(areas) {
  if (!areas || areas.length === 0) return '';
  const eligibleAreas = areas.map((loc) => `${loc.name}, ${loc.state}`);
  return eligibleAreas.join('; ');
}

const convertAgesForDisplay = (count, units) => {
  if (units === 'years' && count < 2) {
    return count * 12;
  }
  if (units === 'months' && count >= 24) {
    return count / 12;
  }
  return count;
};

const convertAgeUnitsForDisplay = (count, units) => {
  if (units?.toLowerCase() === 'years' && count < 2) {
    return 'months';
  }
  if (units?.toLowerCase() === 'months' && count >= 24) {
    return 'years';
  }
  return units;
};

export function formatAgeRange(ages, formatMessage) {
  if (!ages) return '';
  const min = ages.min_months;
  const max = ages.max_months;
  const ageMinConverted = min ? convertAgesForDisplay(min, 'months') : '';
  const ageMinConvertedUnits = min
    ? convertAgeUnitsForDisplay(min, 'months')
    : '';
  const ageMaxConverted = max ? convertAgesForDisplay(max - 1, 'months') : '';
  const ageMaxConvertedUnits = max
    ? convertAgeUnitsForDisplay(max - 1, 'months')
    : '';

  if (!ageMinConverted && !ageMaxConverted) {
    return '';
  }

  if (!ageMinConverted !== !ageMaxConverted) {
    if (ageMinConverted) {
      if (ageMinConvertedUnits === 'years') {
        return formatMessage({
          id: 'ageRange.min.years',
          defaultMessage: 'from {minAge} years old',
        }, {
          minAge: ageMinConverted,
        });
      }
      return formatMessage({
        id: 'ageRange.min.months',
        defaultMessage: 'from {minAge} months old',
      }, {
        minAge: ageMinConverted,
      });
    }
    if (ageMaxConvertedUnits === 'years') {
      return formatMessage({
        id: 'ageRange.max.years',
        defaultMessage: 'up to {maxAge} years old',
      }, {
        maxAge: ageMaxConverted,
      });
    }
    return formatMessage({
      id: 'ageRange.max.months',
      defaultMessage: 'up to {maxAge} months old',
    }, {
      maxAge: ageMaxConverted,
    });
  }

  if (ageMinConvertedUnits === 'months' && ageMaxConvertedUnits === 'months') {
    return formatMessage({
      id: 'ageRange.months',
      defaultMessage: '{minAge} to {maxAge} months old',
    }, {
      minAge: ageMinConverted,
      maxAge: ageMaxConverted,
    });
  }
  if (ageMinConvertedUnits === 'years' && ageMaxConvertedUnits === 'years') {
    return formatMessage({
      id: 'ageRange.years',
      defaultMessage: '{minAge} to {maxAge} years old',
    }, {
      minAge: ageMinConverted,
      maxAge: ageMaxConverted,
    });
  }
  if (ageMinConvertedUnits === 'months' && ageMaxConvertedUnits === 'years') {
    return formatMessage({
      id: 'ageRange.monthsToYears',
      defaultMessage: '{minAge} months to {maxAge} years old',
    }, {
      minAge: ageMinConverted,
      maxAge: ageMaxConverted,
    });
  }
  return '';
}

// eslint-disable-next-line max-len
export const isRichTextEmpty = (richText) => (isEmpty(richText) || richText === EMPTY_DRAFT_FIELD ? null : richText);
